"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
exports.Wrapper = styled_components_1.default.section `
  ${({ theme, background }) => (0, styled_components_1.css) `
    width: 100%;
    padding: ${theme.spacing.unit * 4}px 0;
    box-sizing: border-box;
    background-color: ${background};

    ${bitcoincom_pkg_theme_1.media.md `
        padding: ${theme.spacing.unit * 5}px 0;
    `}

    ${bitcoincom_pkg_theme_1.media.xl `
        padding: ${theme.spacing.unit * 10}px 0;
    `}
  `}
`;
exports.default = exports.Wrapper;
//# sourceMappingURL=styled.js.map